import { useQueryParam } from "~/common/hooks/useQueryParams";
import CreateCaseForm from "../../CreateCaseForm";
import { ExtractedDataPreviewPanel } from "../ExtractedDataPreviewPanel";

export const CaseCreationPreview = () => {
  const [docId] = useQueryParam("documentId");
  const documentId = docId ? parseInt(docId) : 0;

  return (
    <ExtractedDataPreviewPanel documentId={documentId}>
      {(extractedData) => <CreateCaseForm extractedData={extractedData} />}
    </ExtractedDataPreviewPanel>
  );
};
